import { createFileRoute } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";
import { UnitTypeModals } from "@/components/unit-type/unit-type-modals";
import UnitTypeTable from "@/components/unit-type/unit-type-table";
import { useTranslate } from "@/hooks/use-translate";
import useAppStore from "@/store";
import { Plus } from "lucide-react";

export const Route = createFileRoute("/(dasboard)/products/types")({
  component: TypeProductsPage,
});

function TypeProductsPage() {
  const store = useAppStore();
  const { t } = useTranslate();
  return (
    <>
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-20">
        <div className="">
          <UnitTypeModals />
          <header className="flex items-center justify-between mb-4">
            <h2 className="text-lg font-semibold"> {t("Unit type")} </h2>
            <Button
              onClick={() => {
                store.display.show("create_unit_type");
              }}
            >
              <Plus className="w-4 h-4" />
              {t("Add unit type")}
            </Button>
          </header>
          <UnitTypeTable />
        </div>
      </div>
    </>
  );
}
